export default __webpack_public_path__ + "static/media/dating-app-concept.87ea2950.jpg";